import { render, staticRenderFns } from "./PartyRating.vue?vue&type=template&id=f6d720a0"
import script from "./PartyRating.vue?vue&type=script&lang=js"
export * from "./PartyRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports